import React from 'react';
import '../stylesheets/CNNHeader.scss';

const CNNHeader = () => {
  const location = window.location.href.endsWith('/') ? window.location.href.substring(0, window.location.href.length - 1) : window.location.href;

  const locationSplit = location.split('/');
  const firstArticleId = locationSplit.includes('interactive') ? locationSplit[5] : locationSplit[3];

  return (
    <section className="cnn-sponsorcontent-header">
      <nav>
        <ul>
          <li>
            <a href="https://www.cnn.com" data-analytics="header_logo">
              <img src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png" alt="CNN Logo Badge" />
            </a>
          </li>
          <li>
            <a href="https://www.cnn.com">Back to CNN </a>
          </li>
        </ul>
      </nav>

      <h1>
        {firstArticleId === 'psychology-of-wealth' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.johnhancock.com/individual.html?cid=US_JH_BR_DI_CNN_ContentPartnership_Advice_GA_CS_LO_DP_SP_DE_00_AWCTR_1x1_20191119_ContentbyJHTopBar_PsychologyofWealth;260653832"
          >
            Content by John Hancock
          </a>
        )}
        {firstArticleId === 'pie-in-the-sky' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.johnhancock.com/individual.html?cid=US_JH_BR_DI_CNN_ContentPartnership_Advice_GA_CS_LO_DP_SP_DE_00_AWCTR_1x1_20191119_ContentbyJHTopBar_PieintheSky;260949058"
          >
            Content by John Hancock
          </a>
        )}
        {firstArticleId === 'generations-of-wealth' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209243;dc_trk_aid=457308468;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua="
          >
            Content by John Hancock
          </a>
        )}
        {firstArticleId === 'wild-in-alaska' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.261209768;dc_trk_aid=457310732;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua="
          >
            Content by John Hancock
          </a>
        )}
        {firstArticleId === 'saving-the-maah-daah-hey' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.263617598;dc_trk_aid=459028073;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua="
          >
            Content by John Hancock
          </a>
        )}
        {firstArticleId === 'the-wealth-diaries' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.263937634;dc_trk_aid=459014970;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua="
          >
            Content by John Hancock
          </a>
        )}
        {firstArticleId === 'calm-after-crisis' && (
          <a
            id="goldBarCta"
            target="_blank"
            rel="noopener noreferrer"
            href="https://ad.doubleclick.net/ddm/trackclk/N781268.8535CNNNETWORK/B23177801.266705300;dc_trk_aid=461829145;dc_trk_cid=121227925;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua="
          >
            Content by John Hancock
          </a>
        )}
      </h1>
    </section>
  );
};

export default CNNHeader;
